/* eslint-disable promise/always-return */
import axios from './axios-util'

import { objectToQueryString } from './url'

/* TODO: Setup env for the API_BASE_url
 * To have a code line like this:
 *  process.env.API_BASE_URL || 'http://localhost:9000',
 */

const defaults = {
  //baseURL: 'https://localhost.paypal.com:8440',
  baseURL: 'https://localhost.paypal.com',
  headers: () => ({
    'Content-Type': 'application/json',
  }),
  error: {
    code: 'INTERNAL_ERROR',
    message:
      'Something went wrong. Please check your internet connection or contact our support.',
    status: 503,
    data: {},
  },
}

const api = (method, url, variables) =>
  new Promise((resolve, reject) => {
    axios({
      url: `${url}`,
      method,
      headers: defaults.headers(),
      params: method === 'get' ? variables : undefined,
      data: method !== 'get' ? variables : undefined,
      paramsSerializer: objectToQueryString,
    }).then(
      (response) => {
        resolve(response.data)
      },
      (error) => {
        if (error.response) {
          reject(error.response.data.error)
        } else {
          reject(defaults.error)
        }
      },
    )
  })

const optimisticUpdate = async (
  url,
  { updatedFields, currentFields, setLocalData },
) => {
  try {
    setLocalData(updatedFields)
    await api('put', url, updatedFields)
  } catch (error) {
    setLocalData(currentFields)
    throw new Error(error)
  }
}

export default {
  get: (...args) => api('get', ...args),
  post: (...args) => api('post', ...args),
  put: (...args) => api('put', ...args),
  patch: (...args) => api('patch', ...args),
  delete: (...args) => api('delete', ...args),
  optimisticUpdate,
}
